// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.salary_temp_outer {
  width: 100%;
  min-height: 450px;
  border: 1px solid #e6e4e4;
  border-radius: 8px;
  background-color: #fafafa;
  padding: 15px;
}

.create_head h3 {
  font-size: 20px;
  color: #2c3e50;
  margin-bottom: 10px;
}

.Temp_name {
  margin: 0px 14px;
  display: flex;
  gap: 6px;
}

.Temp_name h4 {
  display: inline-block;
  font-size: 16px;
  color: #34495e;
  margin-right: 10px;
}

.Temp_name input {
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  width: 250px;
  font-size: 14px;
}

.all_copm_Outer {
  display: flex;
  gap: 20px;
  width: 100%;
  flex-wrap: wrap;
  border: 1px solid #dbdbdb;
  border-radius: 8px;
  padding: 20px;
  background-color: #ffffff;
}

.all_comp_table {
  border: 1px solid #b5b5b5;
  border-radius: 8px;
  width: 45%;
  max-height: 300px;
  overflow-y: auto;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.05);
}

.all_comp_table::-webkit-scrollbar {
  width: 6px;
}

.all_comp_table::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 3px;
}

.all_comp_table table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 5px;
}

.all_comp_table th {
  background-color: #deecdd;
  position: sticky;
  top: 0;
  text-align: center;
  padding: 10px;
  font-size: 14px;
  color: #2c3e50;
  border-bottom: 1px solid #ccc;
}

.all_comp_table tbody tr {
  transition: background-color 0.2s ease;
}

.all_comp_table tbody tr:nth-child(odd) {
  background-color: #f4f4f4;
}

.all_comp_table td {
  cursor: pointer;
  font-weight: 500;
  font-size: 13px;
  text-align: center;
  padding: 8px;
  vertical-align: middle;
}

.all_comp_table button {
  cursor: pointer;
  padding: 4px 10px;
  font-size: 11px;
  border: none;
  border-radius: 4px;
  transition: background 0.3s ease;

  color: #df3232;
}

.all_comp_table button:hover {
  background-color: #d3dbe0;
}

.all_comp_table button.remove-btn {
  background-color: #e74c3c;
}

.all_comp_table button.remove-btn:hover {
  background-color: #c0392b;
}

.temp_back_btn_container {
  display: flex;
  margin-top: -9px;
  gap: 5px;
}

.temp_back_btn_container button {
  cursor: pointer;
  padding: 6px 12px;
  /* background-color: #7f8c8d; */
  /* color: white; */
  border: none;
  border-radius: 4px;
  transition: background 0.3s ease;
}

.temp_back_btn_container button:hover {
  background-color: #e2e8ea;
}

.submit_template_btn{
  background-color: rgb(132, 199, 174);
  color: white;
  padding:8px;
  border-radius: 8px;
  font-size:12px;
}`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/GenerateSalaryComponent/SalaryTemplate/salaryTemplate.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,4DAA4D;AAC9D;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,MAAM;EACN,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;;EAEhC,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.salary_temp_outer {\n  width: 100%;\n  min-height: 450px;\n  border: 1px solid #e6e4e4;\n  border-radius: 8px;\n  background-color: #fafafa;\n  padding: 15px;\n}\n\n.create_head h3 {\n  font-size: 20px;\n  color: #2c3e50;\n  margin-bottom: 10px;\n}\n\n.Temp_name {\n  margin: 0px 14px;\n  display: flex;\n  gap: 6px;\n}\n\n.Temp_name h4 {\n  display: inline-block;\n  font-size: 16px;\n  color: #34495e;\n  margin-right: 10px;\n}\n\n.Temp_name input {\n  padding: 6px 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  width: 250px;\n  font-size: 14px;\n}\n\n.all_copm_Outer {\n  display: flex;\n  gap: 20px;\n  width: 100%;\n  flex-wrap: wrap;\n  border: 1px solid #dbdbdb;\n  border-radius: 8px;\n  padding: 20px;\n  background-color: #ffffff;\n}\n\n.all_comp_table {\n  border: 1px solid #b5b5b5;\n  border-radius: 8px;\n  width: 45%;\n  max-height: 300px;\n  overflow-y: auto;\n  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.05);\n}\n\n.all_comp_table::-webkit-scrollbar {\n  width: 6px;\n}\n\n.all_comp_table::-webkit-scrollbar-thumb {\n  background-color: #ccc;\n  border-radius: 3px;\n}\n\n.all_comp_table table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0 5px;\n}\n\n.all_comp_table th {\n  background-color: #deecdd;\n  position: sticky;\n  top: 0;\n  text-align: center;\n  padding: 10px;\n  font-size: 14px;\n  color: #2c3e50;\n  border-bottom: 1px solid #ccc;\n}\n\n.all_comp_table tbody tr {\n  transition: background-color 0.2s ease;\n}\n\n.all_comp_table tbody tr:nth-child(odd) {\n  background-color: #f4f4f4;\n}\n\n.all_comp_table td {\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 13px;\n  text-align: center;\n  padding: 8px;\n  vertical-align: middle;\n}\n\n.all_comp_table button {\n  cursor: pointer;\n  padding: 4px 10px;\n  font-size: 11px;\n  border: none;\n  border-radius: 4px;\n  transition: background 0.3s ease;\n\n  color: #df3232;\n}\n\n.all_comp_table button:hover {\n  background-color: #d3dbe0;\n}\n\n.all_comp_table button.remove-btn {\n  background-color: #e74c3c;\n}\n\n.all_comp_table button.remove-btn:hover {\n  background-color: #c0392b;\n}\n\n.temp_back_btn_container {\n  display: flex;\n  margin-top: -9px;\n  gap: 5px;\n}\n\n.temp_back_btn_container button {\n  cursor: pointer;\n  padding: 6px 12px;\n  /* background-color: #7f8c8d; */\n  /* color: white; */\n  border: none;\n  border-radius: 4px;\n  transition: background 0.3s ease;\n}\n\n.temp_back_btn_container button:hover {\n  background-color: #e2e8ea;\n}\n\n.submit_template_btn{\n  background-color: rgb(132, 199, 174);\n  color: white;\n  padding:8px;\n  border-radius: 8px;\n  font-size:12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
